(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.stockholm-living.controller
  (:require
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.stockholm-living.controller.debt-financing
    :refer [debt-financing]]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.stockholm-living.controller.details-and-figures
    :refer [details-and-figures]]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.stockholm-living.controller.financial-statements
    :refer [financial-statements]]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.stockholm-living.controller.inrev-nav
    :refer [inrev-nav]]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.stockholm-living.controller.overview
    :refer [overview]]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.stockholm-living.controller.tearsheet
    :refer
    [tearsheet]]))

(defn ->ui-data
  [{:keys [report-data] :as props}]
  {:fund-name      (:fund-name report-data)
   :reference-date (:reference-date report-data)
   :tearsheet      (tearsheet (update props :dynamic-path concat [:tearsheet]))
   :overview       (overview (update props :dynamic-path concat [:overview]))
   :inrev-nav      (inrev-nav (update props :dynamic-path concat [:inrev-nav]))
   :debt-financing (debt-financing (update props :dynamic-path concat [:debt-financing]))
   :details-and-figures (details-and-figures
                         (update props :dynamic-path concat [:details-and-figures]))
   :financial-statements (financial-statements
                          (update props :dynamic-path concat [:financial-statements]))})
